module.exports = __webpack_public_path__ + "img/loader.c0a5280a.svg";